export const userConstatnt = {
    USERDATA: 'USERDATA',
    MENUID: 'MENUID',
    MENUITEMS: 'MENUITEMS',
    LOCATIONS: 'LOCATIONS'
}

export const updatedConstants = {
    UPDATED: 'UPDATED',
    UPDATEDCLEAR: 'UPDATEDCLEAR'
}